import { Component, Input } from '@angular/core';
@Component({
	selector: 'app-suprimento-tab',
  	templateUrl: './tab.component.html',
  	styleUrls: ['./tab.component.scss']
})
export class SuprimentoTabComponent{
	@Input() desativado:boolean = false;;
}
